import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Button, NoData } from 'components'
import Native from 'library/native'
import { useRecoilState } from 'recoil'
import { showCertiBringLayerState } from 'states/certiState'
import CertiBring from './CertiBring';
import Lib from 'library';

const CertiManage = () => {

	const App = useApp()
	const [data, setData] = useState();
	const [isOver, setIsOver] = useState(false);
	const user = App?.user;
	const [showCertiBringLayer, setShowCertiBringLayer] = useRecoilState(showCertiBringLayerState);

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})
		App.setShowNav(false)
		App.setMainClass("white")
		getCertList();
	}, [])

	const onClick = (sn) => {
		/* setData(data.map(item => {
			if (item.serial === sn) {
				item.selected = !item.selected
			}
			return item
		})) */
	}

	const getCertList = () => {
		Native.execute("Cert", "certList", function (result) {
			const data = JSON.parse(result).result
			setData(data)
		}, {})
	}

	const onAddCert = () => setShowCertiBringLayer(true);

	return (
		<div className="page">
			<div className="flex_1 padding">
				<div style={{ fontSize: "2rem", fontWeight: 500 }}>인증서 목록</div>
				<ul className="document-select mt_40">
					{
						data ? (
							data.length > 0 
								? (
									data.map((item, index) => {
										return (
											<li key={index} onClick={() => onClick(item.serial)}>
												<i className="icon icon_document" />
												<div className="ml_20">
													<p>{user && user.mbNm}</p>
													<ul className="mt_10">
														<li>
															<span>발급자</span>
															<span>{item.auth}</span>
														</li>
														<li>
															<span>용도</span>
															<span>{item.usage}</span>
														</li>
														<li>
															<span>만료일</span>
															<span>
																	{item.expiredDate}
																	{ !isOver && 
																		<i className="tag tag-round tag-red ml_5">
																			{(() => {
																				const date = Lib.ChanageNewDate(item.expiredDate.replace(/-/g, "/"))
																				const today = new Date()
																				if (today > date) {
																					setIsOver(true);
																				} else if (today.getTime() + (1000 * 60 * 60 * 24 * 30) > date.getTime()) {
																					const distance = today.getTime() - date.getTime()
																					const day = Math.floor(distance / (1000 * 60 * 60 * 24))
																					setIsOver(false);
																					return `D-${day}`
																				}
																			})()}
																		</i>
																	}
															</span>
														</li>
													</ul>
												</div>
											</li>
										)
									})
								) : (
									<NoData />
								)
						) : (
							<li>
								<i className="icon icon_document" />
								<div className="ml_20">
									<p className="skeleton" style={{ width: '5rem', height: '2rem' }}></p>
									<ul className="mt_10">
										<li>
											<span>발급자</span>
											<span className="skeleton" style={{ width: '5rem', height: '1.8rem' }}></span>
										</li>
										<li>
											<span>용도</span>
											<span className="skeleton" style={{ width: '5rem', height: '1.8rem' }}></span>
										</li>
										<li>
											<span>만료일</span>
											<span className="skeleton" style={{ width: '8rem', height: '1.8rem' }}></span>
										</li>
									</ul>
								</div>
							</li>
						)
					}
					{/* <li>
						<i className="icon icon_document" />
						<div className="ml_20">
							<p>김모니</p>
							<ul className="mt_10">
								<li>
									<span>발급자</span>
									<span>금융결제원</span>
								</li>
								<li>
									<span>용도</span>
									<span>은행/보험용</span>
								</li>
								<li>
									<span>만료일</span>
									<span>2022년 4월 7일<i className="tag tag-round tag-red ml_5">D-46</i></span>
								</li>
							</ul>
						</div>
					</li>
					<li>
						<i className="icon icon_document warn" />
						<div className="ml_20">
							<p>김모니</p>
							<ul className="mt_10">
								<li>
									<span>발급자</span>
									<span>코스콤</span>
								</li>
								<li>
									<span>용도</span>
									<span>증권용</span>
								</li>
								<li>
									<span>만료일</span>
									<span>2022년 9월 7일<i className="tag tag-round tag-red ml_5">D-6</i></span>
								</li>
							</ul>
						</div>
					</li>
					<li className="over">
						<i className="icon icon_document over" />
						<div className="ml_20">
							<p>김모니</p>
							<ul className="mt_10">
								<li>
									<span>발급자</span>
									<span>코스콤</span>
								</li>
								<li>
									<span>용도</span>
									<span>증권용</span>
								</li>
								<li>
									<span>만료일</span>
									<span>2021년 4월 7일</span>
								</li>
							</ul>
						</div>
					</li> */}
				</ul>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big" onClick={onAddCert}>인증서 가져오기</Button>
			</div>

			<CertiBring />
		</div>
	)
}

export default CertiManage
